function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9432 30H29.2386V27.9886H24.3523V27.9091L26.0511 26.2443C28.4432 24.0625 29.0852 22.9716 29.0852 21.6477C29.0852 19.6307 27.4375 18.2045 24.9432 18.2045C22.5 18.2045 20.8239 19.6648 20.8295 21.9489H23.1648C23.1591 20.8352 23.8636 20.1534 24.9261 20.1534C25.9489 20.1534 26.7102 20.7898 26.7102 21.8125C26.7102 22.7386 26.142 23.375 25.0852 24.392L20.9432 28.2273V30Z",
  fill: "white"
});

function SvgBulletIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletIcon2);
export default __webpack_public_path__ + "static/media/bulletIcon2.79cd140f.svg";
export { ForwardRef as ReactComponent };